import { render, staticRenderFns } from "./OrderActions.vue?vue&type=template&id=1159f7a4&scoped=true&"
import script from "./OrderActions.vue?vue&type=script&lang=js&"
export * from "./OrderActions.vue?vue&type=script&lang=js&"
import style0 from "./OrderActions.vue?vue&type=style&index=0&id=1159f7a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1159f7a4",
  null
  
)

export default component.exports